import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import Layout from './components/Layout'
import PublicLayout from './components/PublicLayout'
import ProtectedRoute from './components/ProtectedRoute'
import NotFound from './pages/NotFound'
import SEO from './components/SEO'
import Chat from './components/Chat'
import ImageGenerator from './components/ImageGenerator'
import VideoGenerator from './components/VideoGenerator'
import MusicGenerator from './components/MusicGenerator'
import Landing from './pages/Landing'
import Login from './pages/Login'
import Register from './pages/Register'
import VerifyEmail from './pages/VerifyEmail'
import Profile from './pages/Profile'
import Admin from './pages/Admin'
import Payment from './pages/Payment'
import Partner from './pages/Partner'

import ApiKeys from './pages/ApiKeys'
import Characters from './pages/Characters'
import CodeAssistant from './pages/CodeAssistant'
import Agents from './pages/Agents'
import AITables from './pages/AITables'
import Translator from './components/Translator'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Support from './pages/Support'
import Pricing from './pages/Pricing'
import ForgotPassword from './pages/ForgotPassword'
import AiModelsPage from './pages/AiModelsPage'
import FaqPage from './pages/FaqPage'

function App() {
  const { checkAuth } = useAuthStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<><SEO canonical="/" /><Landing /></>} />
      <Route path="/login" element={<><SEO canonical="/login" /><Login /></>} />
      <Route path="/register" element={<><SEO canonical="/register" /><Register /></>} />
      <Route path="/verify-email" element={<><SEO title="Подтверждение email" description="Подтверждение email адреса" noIndex /><VerifyEmail /></>} />
      <Route path="/terms" element={<PublicLayout><SEO canonical="/terms" /><Terms /></PublicLayout>} />
      <Route path="/privacy" element={<PublicLayout><SEO canonical="/privacy" /><Privacy /></PublicLayout>} />
      <Route path="/support" element={<PublicLayout><SEO canonical="/support" /><Support /></PublicLayout>} />
      <Route path="/pricing" element={<PublicLayout><SEO canonical="/pricing" /><Pricing /></PublicLayout>} />
      <Route path="/forgot-password" element={<><SEO canonical="/forgot-password" noIndex /><ForgotPassword /></>} />
      <Route path="/reset-password" element={<><SEO canonical="/reset-password" noIndex /><ForgotPassword /></>} />
      <Route path="/ai-models" element={<PublicLayout><SEO canonical="/ai-models" /><AiModelsPage /></PublicLayout>} />
      <Route path="/faq" element={<PublicLayout><SEO canonical="/faq" /><FaqPage /></PublicLayout>} />
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />

      {/* Protected routes with layout */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/chat" element={<><SEO canonical="/chat" /><Chat /></>} />
        <Route path="/chat/:id" element={<><SEO canonical="/chat" /><Chat /></>} />
        <Route path="/image" element={<><SEO canonical="/image" /><ImageGenerator /></>} />
        <Route path="/video" element={<><SEO canonical="/video" /><VideoGenerator /></>} />
        <Route path="/music" element={<><SEO canonical="/music" /><MusicGenerator /></>} />
        <Route path="/characters" element={<><SEO canonical="/characters" /><Characters /></>} />
        <Route path="/code" element={<><SEO canonical="/code" /><CodeAssistant /></>} />
        <Route path="/agents" element={<><SEO canonical="/agents" /><Agents /></>} />
        <Route path="/translator" element={<><SEO canonical="/translator" /><Translator /></>} />
        <Route path="/sheets" element={<><SEO canonical="/sheets" /><AITables /></>} />
        <Route path="/profile" element={<><SEO title="Профиль — Настройки аккаунта" description="Управление профилем, токенами и настройками моделей." noIndex /><Profile /></>} />
        <Route path="/payment" element={<><SEO title="Тарифы — Chat-Neuro.ru" description="Выберите тариф Chat-Neuro.ru. Бесплатный с безлимитными моделями, Стандарт и Премиум с токенами." canonical="/payment" /><Payment /></>} />
        <Route path="/partner" element={<><SEO title="Партнёрская программа — Chat-Neuro.ru" description="Приглашайте друзей в Chat-Neuro.ru и получайте бонусные токены за каждого приглашённого." canonical="/partner" /><Partner /></>} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  )
}

export default App
